/**
 * Creates a React Query mutation error handler that extracts the first API
 * error string, falling back to a generic message when the response has no
 * structured errors (e.g. network errors, unexpected 5xx shapes).
 * @param {Function} createNotification - notification creator from useNotification()
 * @returns {Function} onError callback for useMutation
 */
export function createMutationErrorHandler(createNotification) {
  return err => {
    const detail = err.response?.data?.errors?.[0]
    createNotification({
      message: detail ? `Something went wrong: ${detail}` : 'Something went wrong',
      variant: 'error',
    })
  }
}
